<template lang="html">
  <div :class='tabs'>
    <ul class='tabs__header'>
      <li v-for='(tab, index) in tabs'
          :key='tab.title'
          @click='selectTab(index)'
          :class='{"tab__selected": (index === selectedIndex)}'>
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'light'
    }
  },
  data () {
    return {
      selectedIndex: 0,
      tabs: []
    }
  },
  created () {
    this.tabs = this.$children
  },
  mounted () {
    this.selectTab(0)
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i)
      })
    }
  }
}
</script>

<style lang="css">

ul.tabs__header {
  display: flex;
  flex-direction: row;
  list-style: none;
  margin: 0 0 0 20px;
  padding: 0;
  justify-content: center;
}

ul.tabs__header > li {
  font-size: 1.2rem;
  padding: 15px 30px;
  border-radius: 10px;
  display: inline-block;
  margin: 0 5px 0 0;
  cursor: pointer;
}

ul.tabs__header > li.tab__selected {
  background-color: rgb(123 58 142 / 0.1);
  font-size: 1.3rem;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  border-bottom: 8px solid transparent;
}

.tab {
  background-color: rgb(123 58 142 / 0.1);
  display: inline-block;
  padding: 20px;
  width: 85%;
  border-radius: 10px;
  min-height: 400px;
}

.tabs li {
  background-color: #ddd;
  color: #aaa;
}

.tabs li.tab__selected {
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue